<se-fe-card>
  <se-fe-card-header
    seFeDataTitle="Feature: Review Household"
    seFeDataSubtitle="Review Household Members"
  ></se-fe-card-header>
  <se-fe-card-content>
    <se-po-review></se-po-review>
  </se-fe-card-content>
</se-fe-card>
